<div class="row">
  <div class="col-sm-9">
    <div class="booking_ht">
      <!-- <sm-title-bar pageTitle="All latest purchase"></sm-title-bar> -->
      <sm-title-bar pageTitle="All latest purchase" [showBackToDashboard]="true"></sm-title-bar>
    </div>
  </div>
  <div class="col-sm-3">
  </div>
</div>


<div class="" *ngIf="!loader">
  <div class="row">
    <div class="col-md-6 col-sm-6 col-12" *ngFor="let data of latestPurchaseData">
    <div class="plan-card" style="position: relative; " >
      
      <div class="d-flex align-items-center" style="position: relative;flex-shrink: 0;">
       
        <!-- <mat-icon
        *ngIf="!data.image_thumb_url || data.image_thumb_url == 'null'"
        [ngStyle]="{backgroundColor: data.purchase_status == 2 ? 'yellow' : data.purchase_status == 1 ? 'green' : 'red' }"
            class="status-icon">
          </mat-icon> -->

             <div class="service-image">
      
        <div style="position: relative;">
          <div class="booking-initial" *ngIf="!data.image_thumb_url || data.image_thumb_url == 'null'">{{data.item_name.slice(0,1).toUpperCase()}}</div>
          <img
          *ngIf="data.image_thumb_url && data.image_thumb_url != 'null'"
            [src]="data.image_thumb_url"
            onerror="this.src='../../../../assets/images/photo.png'"
            class="img-fluid rounded-circle"
            style="border: 1px solid lightgray; width: 50px; height: 50px; object-fit: cover;"
          />
          <mat-icon
          *ngIf="data.purchase_status == 1"
            class="status-icon"
            style="background-color: green;
            position: absolute;
            bottom: -4px;
            color: #fff;
            border-radius: 50%;
            left: 30px;
            width: 20px;
            font-size: 20px;
            height: 20px;"
            class="material-icons-round"
          >check</mat-icon>
          <mat-icon
          *ngIf="data.purchase_status == 2"          
            class="status-icon"
            style="background-color: #ffc107;
            position: absolute;
            bottom: -4px;
            color: #fff;
            border-radius: 50%;
            left: 30px;
            width: 20px;
            font-size: 20px;
            height: 20px;"
            class="material-icons-round"
          >schedule</mat-icon>
          <mat-icon
          *ngIf="data.purchase_status == 3"
            class="status-icon"
            style="background-color: red;
            position: absolute;
            bottom: -4px;
            color: #fff;
            border-radius: 50%;
            left: 30px;
            width: 20px;
            font-size: 20px;
            height: 20px;"
            class="material-icons-round"
          >close</mat-icon>
        </div>

        
      </div>

        <!-- <div class="booking-initial" *ngIf="!data.image_thumb_url || data.image_thumb_url == 'null'">{{data.item_name.slice(0,1).toUpperCase()}}</div> -->
        <!-- <div class="booking-initial-img" style="position: relative; flex-shrink: 0;" *ngIf="data.image_thumb_url && data.image_thumb_url != 'null'">
          <img style="height: 50px;width: 50px;"  [src]="data.image_thumb_url" onerror="this.src='../../../../../assets/images/purchase-placeholder.jpeg'"
            alt="" class="img-fluid rounded-circle booking-initial-img">
          <span [ngStyle]="{backgroundColor: data.purchase_status == 2 ? 'yellow' : data.purchase_status == 1 ? 'green' : 'red' }" style="width: 15px; height:15px; display: block;position: absolute;    
           bottom: 0px;
    right: 0px; border-radius: 50%; background-color: red"></span>
        </div> -->
        <div class="m-2 data_list_r">
          <h2 class="plan-title"> {{ data.item_name }}</h2>
          <p class="plan-info">
            <span class="valueque"> {{data.purchase_quantity}} {{data.purchase_unit}}, {{data.purchase_price }}</span>
          </p>
        </div>
      </div>
      <!-- <p class="plan-cost my-3">
        <span class="value"></span> 
      </p> -->
      <p class="plan-cost">
        <span class="value">{{ data.name }}</span> 
      </p>
      <p><span class="label addr">{{ data.address_line}} </span></p>
      <p class="plan-cost">
        <span class="value">{{ data.purchase_date }}</span>
      </p>
    </div>
  </div>
  </div>
</div>


<!-- 
<mat-card appearance="outlined" *ngIf="!loader && latestPurchaseData.length > 0">
  <div class="rounded-3 bg-light">
    <sm-data-table [columnHeaders]="tableDisplayColumns" [showImageColumn]="true" [imageTemplate]="image"
      [dataSource]="latestPurchaseData" [showPagination]="true" [itemsPerPage]="25">
    </sm-data-table>
  </div>
</mat-card>
<ng-template #menuTemplate let-rowvalue>
  <button mat-menu-item>
    <mat-icon class="material-icons-outlined">check_circle</mat-icon>
    <span>Edit</span>
  </button>
  <button mat-menu-item>
    <mat-icon class="material-icons-outlined">timer</mat-icon>
    <span>Delete</span>
  </button>
</ng-template>
<ng-template #image let-objValue>
  <img [src]="
          objValue['image_thumb_url'] !== null && objValue['image_thumb_url'] !== 'null' && objValue['image_thumb_url'] !== ''
            ? objValue['image_thumb_url']
            : './assets/images/salon_support_header.png'
        " class="img-fluid rounded-circle" />
</ng-template> -->